<template>
  <a-button size="large" type="primary" @click="showModal">{{ $t("createNewTask") }}</a-button>
  <a-modal v-model:visible="visible"
           :title="$t('createNewTask')"
           style="width: 60%;top: 20px"
           :ok-text="$t('submit')"
           :cancel-text="$t('cancel')"
           @ok="handleOk"
  >
    <a-form
        ref="taskForm"
        :model="task"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
    >
      <a-form-item
          :label="$t('animalType')"
          name="animaltype"
          :rules="[{ required: true, message: $t('pleaseSelect') + $t('animalType') }]"
      >
        <select-id-and-name :list="animalTypeList" option-value="id" option-text="name"
                            v-model:value="task.animaltype"></select-id-and-name>
      </a-form-item>
      <a-form-item
          :label="$t('geneName')"
          name="genename"
          :rules="[{ required: true, message: $t('pleaseEnter') + $t('geneName') }]"
      >
        <a-input v-model:value="task.genename"/>
      </a-form-item>
      <a-form-item
          :label="$t('editType')"
          name="edittype"
          :rules="[{ required: true, message: $t('pleaseSelect') + $t('editType') }]"
      >
        <select-id-and-name :list="editTypeList" option-value="id" option-text="name"
                            v-model:value="task.edittype" sort-by="id"></select-id-and-name>
      </a-form-item>
      <a-form-item
          :label="$t('other')"
          name="other"
          v-if="task.edittype === '07'"
      >
        <a-input v-model:value="task.otheredit"/>
      </a-form-item>
      <a-form-item
          :label="$t('description')"
          name="description"
      >
        <a-textarea v-model:value="task.description" :rows="4"/>
      </a-form-item>
      <a-form-item
          :label="$t('uploadFile')"
      >
        <cibr-file-upload :detail-id="task.key" @fileChange="changeFile"></cibr-file-upload>
      </a-form-item>
      <a-form-item
          :label="$t('proxyOrder')"
          v-if="isAdmin"
      >
        <select-id-and-name :list="userList" option-value="id" option-text="name"
                            v-model:value="task.proxy"></select-id-and-name>
      </a-form-item>
      <a-form-item
          :label="$t('email')"
          v-if="isAdmin"
      >
        <a-checkbox v-model:checked="sendEmail" >
          {{ $t("sendEmail") }}
        </a-checkbox>
      </a-form-item>
    </a-form>
  </a-modal>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/12 14:35
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import SelectIdAndName from "@/components/public/selectIdAndName";
import CibrFileUpload from "@/components/public/cibrFileUpload";

export default {
  name: "createNewTask",
  components: {CibrFileUpload, SelectIdAndName, VLoading},
  data() {
    return {
      loading: false,
      visible: false,
      sendEmail: true,
      task: {
        key: util.getUUID(),
        animaltype: "",
        genename: "",
        edittype: "",
        description: "",
        otheredit : "",
        fileList: [],
        proxy : ""
      },
      userList : []
    }
  },
  mounted() {
  },
  methods: {
    handleOk() {
      this.$refs.taskForm.validate().then(() => {
        if (this.task.edittype === '07' && util.isNull(this.task.otheredit)){
          util.notificationError(this.$t("pleaseEnter") + this.$t("otherEditType"))
          return;
        }
        var post = {
          task : JSON.stringify(this.task),
          sendEmail: this.sendEmail
        }
        util.$post("/task/create/submit", post, () => {
          this.visible = false;
          util.submitSuccess();
          this.$emit("createSuccess")
        }, this.showMask, this.hideMask);
      })
    },
    changeFile(params) {
      this.task.fileList = params.fileList;
    },
    showModal() {
      this.visible = true;
      this.task = {
        key: util.getUUID(),
        animaltype: "",
        genename: "",
        edittype: "",
        description: "",
        otheredit : "",
        fileList: [],
        proxy : ""
      }
      this.initPage();
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {}
      util.$post("/task/create/initPage", post, (res) => {
        this.userList = res.userList;
      }, this.showMask, this.hideMask);
    }
  },
  computed: {
    animalTypeList() {
      return util.animalTypeList();
    },
    editTypeList() {
      return util.editTypeList();
    },
    isAdmin(){
      return this.$store.getters.isGeneticAdmin;
    }
  }
}
</script>

<style scoped>

</style>